export default "__VITE_ASSET__BwXPeXV4__"